module.exports = __webpack_public_path__ + "c25838e07bf0c7ce09418d98f4c79961.png";